"use client";

/**
 * 앱으로 넘기는 콜백 — 어느 자리에서 넘겼는지 남기고 같은 경로를 앱에서 연다.
 * @description 앱이 없으면 `openInApp` 이 스토어로 보낸다. 자리(`placement`)마다 계측이 갈린다 —
 *   2.0 상세의 `Collab App Opened` 와 같은 이벤트다.
 * @example const openFee = useCollabV3OpenApp(subject, "fee", paths.fee);
 */
import { useCallback } from "react";

import {
  trackCollabV3AppOpened,
  type CollabV3AppOpenPlacement,
  type CollabV3EventSubject,
} from "../../analytics";
import { openInApp } from "@/shared/lib/deepLink";

export function useCollabV3OpenApp(
  subject: CollabV3EventSubject,
  placement: CollabV3AppOpenPlacement,
  path: string,
): () => void {
  return useCallback(() => {
    trackCollabV3AppOpened(subject, placement);
    openInApp(path);
  }, [subject, placement, path]);
}
